import React from 'react';

const faqs = [
  {
    question: 'What advertising services does In Smart Media offer?',
    answer: 'In Smart Media offers 50+ advertising services including E-Rickshaw branding, street hoardings, social media marketing, radio and TV advertising, print media, digital marketing, holography advertising, mobile van branding, and event management.'
  },
  {
    question: 'How many years of experience does In Smart Media have?',
    answer: 'In Smart Media has more than 17 years of experience in advertising. Its founders bring more than 23 years of media and advertising experience.'
  },
  {
    question: 'Where is In Smart Media located?',
    answer: 'In Smart Media is located near ESI Hospital on Hotagi Road in Solapur, Maharashtra, India.'
  },
  {
    question: 'How can I contact In Smart Media?',
    answer: 'Call +91-8625011717 or +91-9765562856, email insmartmedia.advt@gmail.com, or send an inquiry through the contact form on this page.'
  }
];

export const FAQ = () => (
  <section id="faq" className="py-20 bg-white" aria-labelledby="faq-heading">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-10">
        <h2 id="faq-heading" className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          Advertising in <span className="text-blue-600">Solapur: FAQs</span>
        </h2>
        <p className="text-xl text-gray-600">
          Answers to common questions about working with In Smart Media.
        </p>
      </div>
      <div className="space-y-4">
        {faqs.map(({ question, answer }) => (
          <details key={question} className="group rounded-xl border border-gray-200 bg-gray-50 p-5">
            <summary className="cursor-pointer list-none pr-8 text-lg font-semibold text-gray-900 marker:hidden">
              {question}
            </summary>
            <p className="mt-4 leading-relaxed text-gray-600">{answer}</p>
          </details>
        ))}
      </div>
    </div>
  </section>
);
